// import { isArray } from "@craco/craco/lib/utils"
// import { areSameObjects } from "../other/Utils"

export default class HttpService {

    url = process.env.REACT_APP_API_URL

    postData = async(item, added_url, tokenId = "") => {
        const token = await localStorage.getItem(tokenId)
        const userLocation = await localStorage.getItem('comelit-user-language')

        const requestOptions = this.postRequestOptions(token, item, userLocation)

        return fetch( this.url + '/' + added_url, requestOptions ).then(
            response => response.json()
        )
    }
    
    getData = async( added_url, tokenId = "", options = null) => {
        const token = await localStorage.getItem(tokenId)
        const userLocation = await localStorage.getItem('comelit-user-language')

        const requestOptions = this.getRequestOptions(token, userLocation)

        const pagination = options && typeof options === 'object' ? options.pagination === true : false
        const page = options && typeof options === 'object' && Number.isInteger(options.page) ? options.page : 0
        const previousResponse = options && typeof options === 'object' && Array.isArray(options.previousResponse) ? options.previousResponse : []

        let urlFetch = added_url
        if (pagination)
            urlFetch = added_url.includes("?") ? `${added_url}&page=${page}` : `${added_url}?page=${page}`

        return fetch( this.url + '/' + urlFetch, requestOptions )
            .then( response => response.json() )
            .then( async newResponse => {

                if (!pagination)
                    return newResponse

                // Si la respuesta no es array la devolvemos
                if (!Array.isArray(newResponse))
                    return newResponse

                const response = [...previousResponse, ...newResponse]

                if (newResponse.length !== 0) {
                    return this.getData(added_url, tokenId, {
                        pagination: true,
                        page: page + 1,
                        previousResponse: response
                    })
                }

                return response
            })
    }
    
    deleteData = async(item, added_url, tokenId = "") => {
        const token = await localStorage.getItem(tokenId)
        const userLocation = await localStorage.getItem('comelit-user-language')

        const requestOptions = this.deleteRequestOptions(token, item, userLocation)

        return fetch( this.url + '/' + added_url, requestOptions ).then(
            response => response.json()
        )
    }

    getHeaders(token, userLocation){
        return {
            'Authorization': 'Bearer ' + token,
            'Content-type': 'application/json',
            'X-localization': userLocation 
        }
    }

    getRequestOptions = (token, userLocation = null) => {
        let headers = this.getHeaders(token, userLocation)
        let requestOptions = {
            method: "GET",
            headers: headers,
            redirect: 'follow'
        }

        return requestOptions
    }
    
    postRequestOptions = (token, item, userLocation = null) => {
        let headers = this.getHeaders(token, userLocation)
        let requestOptions = {
            method: "POST",
            headers: headers,
            body: JSON.stringify(item),
            redirect: 'follow'
        }

        return requestOptions
    }

    deleteRequestOptions = (token, item, userLocation = null) => {
        let headers = this.getHeaders(token, userLocation)
        let requestOptions = {
            method: "DELETE",
            headers: headers,
            body: JSON.stringify(item),
            redirect: 'follow'
        }

        return requestOptions
    }
}